import { Component } from '@angular/core'

@Component({
  selector: 'icon-ca-flag',
  templateUrl: './ca-flag.icon.html',
})
export class CAFlagIconComponent {}
